import { videoUrl } from '@helpers/cloudinary';
import { getSrcs } from '@helpers/image';
import { until } from '@helpers/media';
import { isMediaVideo } from '@helpers/video';
import { withMotionMax } from '@hoc/withMotionMax';
import { useModalGallery } from '@hooks/useModalGallery';
import ModalGallery from '@stories/Components/Misc/ModalGallery/ModalGallery';
import ModalGalleryProvider from '@stories/Components/Misc/ModalGallery/ModalGalleryProvider/ModalGalleryProvider';
import * as React from 'react';
import S from './MediaEmbed.styles';
const MediaEmbed = ({ media, caption, ...rest }) => {
    if (!media) {
        return null;
    }
    useModalGallery({ count: 1 });
    const [modalOpen, setModalOpen] = React.useState(false);
    const srcs = !isMediaVideo(media)
        ? getSrcs(media, 840, 284, 5)
        : media.previewImage
            ? getSrcs(media.previewImage, 840, 284, 5, 9 / 16)
            : [videoUrl(media.videoId, { format: 'jpg' })];
    const sizes = `${until(840)} 100vw, 840px`;
    return (React.createElement(S.Container, { ...rest },
        React.createElement(ModalGalleryProvider, { count: 1 },
            React.createElement(S.MediaInner, { onClick: () => {
                    setModalOpen(true);
                } },
                isMediaVideo(media) ? (React.createElement(S.VideoWrapper, null,
                    React.createElement(S.Image, { sizes: sizes, src: srcs[0].split(' ')[0], srcSet: srcs.join(','), alt: media.title ?? undefined, loading: "lazy", role: !media.title ? 'presentation' : undefined }))) : (React.createElement(S.Image, { sizes: `${until(840)} 100vw, 840px`, src: srcs[0].split(' ')[0], srcSet: srcs.join(','), alt: media.altText ?? undefined, loading: "lazy", role: !media.altText ? 'presentation' : undefined })),
                caption && React.createElement(S.Caption, null, caption)),
            React.createElement(ModalGallery, { ariaLabel: "Dummy Modal Gallery", isOpen: modalOpen, openIndex: 0, media: [media], closeOnBackground: true, showBackground: true, showClose: true, onClose: () => setModalOpen(false) }))));
};
export default withMotionMax(MediaEmbed);
